import React, { Component } from 'react';
import Navbar from '../../../_components/common/Navbar';
import { CommonBreadCrumb } from '../../../_components/common/CommonBreadCrumb';
import { connect } from 'react-redux';
import { organisationAction } from '../../../_actions/organisation.action';
import { Input } from 'reactstrap';
import downloadCsv from 'download-csv';
import { csvDownloadAction } from '../../../_actions';
import swal from 'sweetalert2';
import { LoaderComp } from '../../../_components/common/LoaderComp/Loadercomp';


class CsvDownload extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orgId: 'null',
            CSVData: null,
            fileName: null,
        }
    }

    componentDidMount() {
        this.props.dispatch(organisationAction.getOrganisation(() => { }));
        this.props.dispatch(organisationAction.getIntrumentList())
    }

    onChangeOrganisation = (ev) => {

        this.setState({
            orgId: ev.target.value,

        })
    }

    onClickCsv = (fileName, id, type) => {
        const data = {
            'organisation_id': this.state.orgId === 'null' ? null : this.state.orgId,
            'instrument_id': id,
            'csv_download_type': type
        }


        function changeKeys(key) {
            switch (key) {
                case 'user_assessment__batch__batch_name':
                    key = 'Batch Name'
                    break;
                case 'user_assessment__organisation_user_assessment_repondents__respondent_submission_date':
                    key = 'Submission Date'
                    break;
                case 'language__language_name':
                    key = 'Language'
                    break;
                case 'question_statement_female':
                    key = 'Question Statement Female'
                    break;
                case 'question_hint':
                    key = 'Question Hint'
                    break;
                case 'question_statement_male':
                    key = 'Question Statement Male'
                    break;
                case 'question_number':
                    key = 'Question Number'
                    break;
                case 'attribute_name':
                    key = 'Attribute Name'
                    break;
                case 'orientation_name':
                    key = 'Orientation Name'
                    break;
                case 'answer_type':
                    key = 'Answer Type'
                    break;
                case 'question_parameter':
                    key = 'Question Parameter'
                    break;
                case 'assessment_question__question_number':
                    key = 'Question Number'
                    break;
                case 'assessment_value':
                    key = 'Assessment Value'
                    break;
                case 'organisation__organisation_name':
                    key = 'Organisation Name'
                    break;
                case 'user__country__country_name':
                    key = 'Country'
                    break;
                case 'user__date_of_birth':
                    key = 'Date of Birth'
                    break;
                case 'user__email':
                    key = 'User Email'
                    break;
                case 'user__full_name':
                    key = 'Full Name'
                    break;
                case 'user__gender':
                    key = 'User Gender'
                    break;
                case 'user__short_name':
                    key = 'Short Name'
                    break;
                case 'assessor_name':
                    key = 'Assessor Name'
                    break;
                case 'assessor_name_plurals':
                    key = 'Assessor Name Plurals'
                    break;
                default:
                    break;
            }
            return key
        }


        this.props.dispatch(csvDownloadAction.csvDownloadHandler(data, () => {
            const csvData = this.props.csvDownloadResponse;
            let keyData = [];
            let fd = [];
            let properKeyData = [];


            this.props.csvDownloadResponse.map(
                (data, i) => {

                    if (i === 0) {
                        let keyDataHere = [];

                        for (const key in data) {
                            if (data.hasOwnProperty(key)) {
                                const val = data[key];
                                if (key !== 'id') {
                                    if (typeof val !== 'object') {
                                        keyDataHere.push(changeKeys(key))
                                    } else {
                                        if (Array.isArray(val)) {

                                            val.map(value => {
                                                Object.keys(value).map(valueStr => {
                                                    keyDataHere.push(changeKeys(valueStr))
                                                })
                                            })
                                        } else if (val === null) {
                                            keyDataHere.push(changeKeys(key))
                                        } else {
                                            for (const object__key in val) {
                                                if (val.hasOwnProperty(object__key)) {
                                                    const el_obj = val[object__key];
                                                    keyDataHere.push(changeKeys(object__key));
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }





                        properKeyData = keyDataHere
                    }
                    let keyDataSingle = []
                    let fdCurrent = []
                    for (let key in data) {
                        if (data.hasOwnProperty(key)) {
                            let element = data[key];
                            if (key !== 'id') {
                                if (element === null) {
                                    fdCurrent.push(`"${'no data'}"`)
                                } else if (typeof element !== 'object') {
                                    const changed__key = changeKeys(key)
                                    keyDataSingle.push(changed__key)
                                    if (key === 'user__gender') {
                                        if (element === '' || element === '3') {
                                            element = 'Others'
                                        } else if (element === '1') {
                                            element = 'Male'
                                        } else if (element === '2') {
                                            element = 'Female'
                                        }
                                        fdCurrent.push(`"${element}"`)
                                    } else {
                                        fdCurrent.push(`"${element}"`)
                                    }
                                } else {
                                    let currentKey = key

                                    if (Array.isArray(element)) {
                                        for (let j = 0; j < element.length; j++) {
                                            const elem = element[j];
                                            for (const currentKey_key in elem) {
                                                if (elem.hasOwnProperty(currentKey_key)) {
                                                    const el = elem[currentKey_key];
                                                    keyDataSingle.push(currentKey_key)
                                                    fdCurrent.push(`"${el}"`)
                                                }
                                            }
                                        }
                                    } else {
                                        for (const object__key in element) {
                                            if (element.hasOwnProperty(object__key)) {
                                                const el_obj = element[object__key];
                                                keyDataSingle.push(object__key)
                                                fdCurrent.push(`"${el_obj}"`)
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    keyData = properKeyData
                    fd.push(fdCurrent)
                }
            )

            if (fd.length !== 0) {
                fd.unshift(keyData)
                downloadCsv(fd, keyData, `${fileName}.csv`);
            } else {
                swal({
                    text: 'No Data Found!',

                    showCancelButton: false,
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'OK'
                })
            }

        })
        )
    }

    render() {

        const { organisationResponse, loading, instrument_full_loading, instrumentListResponse } = this.props;
        return (
            <div>
                <Navbar />
                <div className="container custom-container my-5" >

                    <div>
                        <CommonBreadCrumb
                            data={[
                                {
                                    link: '/admin/app/dashboard',
                                    name: 'ADMIN'
                                }, {
                                    link: '',
                                    name: 'CSV DOWNLOADS'
                                }
                            ]}
                        />
                    </div>
                    <div className="bg-green rounded-top position-relative mt-3 animation-fade-in">
                        {
                            (instrument_full_loading) ?
                                <div className="d-flex justify-content-between">
                                    <p></p>
                                    <p className="text-center text-uppercase py-2 text-white mb-0 quattrocentosans regular"> CSV DOWNLOADS  </p>
                                    <LoaderComp color={'white'} />
                                </div>
                                :
                                <p className="text-center text-uppercase py-2 text-white mb-0 quattrocentosans regular"> CSV DOWNLOADS  </p>
                        }
                    </div>


                    <div className="d-flex flex-row">
                        <div className="col-md-6 col-12 px-0 my-2 mx-md-5 mx-0">
                            <div className="d-flex flex-row">
                                <span className="col-4 mt-2"> Organisation &nbsp;
                                    {
                                        loading &&
                                        <i className="fas fa-spinner fa-spin text-black spinner-position" ></i>
                                    }
                                </span>

                                <Input
                                    value={this.state.orgId}
                                    type="select" name="field"
                                    bsSize="sm" className="col-6 border-1"
                                    onChange={this.onChangeOrganisation}
                                >
                                    <option value='null' key={0}>All</option>;
                                    {
                                        !loading &&
                                        organisationResponse.map(
                                            (organisation, i) => {
                                                return <option
                                                    value={organisation.id} key={i}>{organisation.organisation_name}</option>;
                                            }
                                        )
                                    }
                                </Input>
                            </div>
                        </div>
                    </div>
                    <div className="mx-md-5 mx-0 mt-4 pb-5">
                        {
                            instrument_full_loading === false && instrumentListResponse !== [] &&
                            instrumentListResponse.map(
                                (response, i) => {
                                    return response.instrument_type === 0 ?
                                        <React.Fragment>
                                            <div className="d-flex flex-row flex-wrap justify-content-start ">

                                                <div className="col-12 col-md-6 col-lg-4 my-2">
                                                    <button style={{ fontSize: 14 }} onClick={() => this.onClickCsv(response.instrument_name + ' QUESTIONNAIRE', response.id, 1)} className="btn btn-block buttonColor customBorderRadius quattrocentosans regular text-white">{response.instrument_name} QUESTIONNAIRE</button>
                                                </div>

                                                <div className="col-12 col-md-6 col-lg-4 my-2">
                                                    <button style={{ fontSize: 14 }} onClick={() => this.onClickCsv(response.instrument_name + ' RESPONSES', response.id, 2)} className="btn btn-block buttonColor customBorderRadius quattrocentosans regular text-white">{response.instrument_name} RESPONSES</button>
                                                </div>

                                                <div className="col-12 col-md-6 col-lg-4 my-2">
                                                    <button style={{ fontSize: 14 }} onClick={() => this.onClickCsv(response.instrument_name + ' RELATIONS', response.id, 3)} className="btn btn-block buttonColor customBorderRadius quattrocentosans regular text-white">{response.instrument_name} RELATIONS</button>
                                                </div>
                                            </div>
                                        </React.Fragment>

                                        :
                                        <React.Fragment>
                                            <div className="d-flex flex-row flex-wrap justify-content-start ">

                                                <div className="col-12 col-md-6 col-lg-4 my-2">
                                                    <button style={{ fontSize: 14 }} onClick={() => this.onClickCsv(response.instrument_name + ' QUESTIONNAIRE', response.id, 1)} className="btn btn-block buttonColor customBorderRadius quattrocentosans regular text-white">{response.instrument_name} QUESTIONNAIRE</button>
                                                </div>

                                                <div className="col-12 col-md-6 col-lg-4 my-2">
                                                    <button style={{ fontSize: 14 }} onClick={() => this.onClickCsv(response.instrument_name + ' RESPONSES', response.id, 2)} className="btn btn-block buttonColor customBorderRadius quattrocentosans regular text-white">{response.instrument_name} RESPONSES</button>
                                                </div>
                                            </div>
                                        </React.Fragment>
                                }
                            )
                        }
                    </div>
                </div>
            </div >
        )
    }
}

function mapStateToProps(state) {

    const { loading } = state.organisation;
    const organisationError = state.organisation.error;
    const organisationResponse = (!loading && !organisationError) ? state.organisation.organisation.data.organisation_list : '';

    const { instrument_full_loading } = state.instrumentListFull;
    const instrumentListFullError = state.instrumentListFull.error;
    const instrumentListResponse = (!instrument_full_loading && !instrumentListFullError) ? state.instrumentListFull.instrument_full_list.instrument_list : '';


    const { csvDownloadLoading } = state.csvDownloadReducer;
    const csvDownloadResponse = (!csvDownloadLoading && !state.csvDownloadReducer.error) ? state.csvDownloadReducer.data.data.response : '';

    return {
        loading,
        organisationResponse,
        instrumentListResponse,
        instrument_full_loading,
        csvDownloadResponse
    }
}


export default connect(mapStateToProps)(CsvDownload);



// WEBPACK FOOTER //
// ./src/_pages/Admin/CsvDownload/index.jsx